<template>
  <v-container
    fluid
  >
    <v-row>
      <v-col
        cols="12"

        md="5"
        lg="4"
        offset-lg="1"
        xl="3"
        offset-xl="2"
      >
        <v-row>
          <v-col>
            <v-card
              elevation="0"
              color="transparent"
            >
              <v-card-text
                class="pa-0"
              >
                <v-row
                  class="px-2"
                >
                  <v-col>
                    <div>
                      <span class="font-weight-bold">店舗コード:</span>
                      {{ baseInfo.store_code }}
                    </div>
                    <div class="text-h6">
                      {{ baseInfo.store_name }}
                    </div>
                  </v-col>
                </v-row>
                <v-row
                  class="px-2 pb-5"
                >
                  <v-col
                    class="pt-0"
                  >
                    <div>
                      {{ baseInfo.pref }}{{ baseInfo.address }}
                    </div>
                  </v-col>
                </v-row>
                <v-divider class="my-3" />
                <v-row
                  class="px-2"
                >
                  <v-col
                    class="font-weight-bold"
                    cols="6"
                    md="4"
                  >
                    店舗オープン
                  </v-col>
                  <v-col
                    cols="6"
                    md="8"
                  >
                    {{ baseInfo.open_date }}
                  </v-col>
                </v-row>
                <v-divider class="my-3" />
                <v-row
                  class="px-2"
                >
                  <v-col
                    class="font-weight-bold"
                    cols="6"
                    md="4"
                  >
                    業種
                  </v-col>
                  <v-col
                    cols="6"
                    md="8"
                  >
                    {{ baseInfo.industry }}
                  </v-col>
                </v-row>
                <v-divider class="my-3" />
                <v-row
                  class="px-2"
                >
                  <v-col
                    class="font-weight-bold"
                    cols="6"
                    md="4"
                  >
                    企業コード
                  </v-col>
                  <v-col
                    cols="6"
                    md="8"
                  >
                    {{ baseInfo.corporation_code }}
                  </v-col>
                </v-row>
                <v-divider class="my-3" />
                <v-row
                  class="px-2"
                >
                  <v-col
                    class="font-weight-bold"
                    cols="6"
                    md="4"
                  >
                    企業名
                  </v-col>
                  <v-col
                    cols="6"
                    md="8"
                  >
                    {{ baseInfo.corporation_name }}
                  </v-col>
                </v-row>
                <v-divider class="my-3" />
              </v-card-text>
            </v-card>

          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="12"
        md="7"
        lg="6"
        xl="5"
      >
        <v-row>
          <v-col>
            <v-card
              elevation="1"
            >
              <v-card-title>導入サービス</v-card-title>
              <v-card-text>
                <v-row>
                  <v-col>
                    <v-divider class="my-3" />
                    <v-row
                      class="px-2"
                    >
                      <v-col
                        class="font-weight-bold"
                        cols="6"
                        md="4"
                      >
                        レポート対象期間
                      </v-col>
                      <v-col
                        cols="6"
                        md="8"
                      >
                        {{ otherService.target_date_from }}
                        ～
                        {{ otherService.target_date_to }}
                      </v-col>
                    </v-row>
                    <v-divider class="my-3" />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card
              elevation="1"
            >
              <v-card-title>店舗規模</v-card-title>
              <v-card-text>
                <v-row>
                  <v-col>
                    <v-divider class="my-3" />
                    <v-row
                      class="px-2"
                    >
                      <v-col
                        class="font-weight-bold"
                        cols="6"
                        md="4"
                      >
                        推定年商（企業）
                      </v-col>
                      <v-col
                        cols="6"
                        md="8"
                      >
                        {{ scale.corporation_estimate_sales }}
                      </v-col>
                    </v-row>
                    <v-divider class="my-3" />
                    <v-row
                      class="px-2"
                    >
                      <v-col
                        class="font-weight-bold"
                        cols="6"
                        md="4"
                      >
                        推定年商（店舗）
                      </v-col>
                      <v-col
                        cols="6"
                        md="8"
                      >
                        {{ scale.store_estimate_sales }}
                      </v-col>
                    </v-row>
                    <v-divider class="my-3" />
                    <v-row
                      class="px-2"
                    >
                      <v-col
                        class="font-weight-bold"
                        cols="6"
                        md="4"
                      >
                        席数
                      </v-col>
                      <v-col
                        cols="6"
                        md="8"
                      >
                        {{ scale.seat_num }}
                      </v-col>
                    </v-row>
                    <v-divider class="my-3" />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import {checkComparison, sendGetParallelApi} from "../../../util";

export default {
  name: 'StoreDetail',
  data () {
    return {
      baseInfo: {
        store_code: '',
        store_name: '',
        corporation_code: '',
        corporation_name: '',
        pref: '',
        address: '',
        open_date: '',
        industry: '',
      },
      scale: {
        corporation_estimate_sales: '',
        store_estimate_sales: '',
        seat_num: ''
      },
      otherService: {
        target_date_from: '',
        target_date_to: '',
        target_days: ''
      }
    }
  },
  async beforeRouteEnter(to, from, next) {
    await checkComparison(function(result) {
      if (result) {
        next()
      } else {
        next('/comparison/base')
      }
    });
  },
  mounted() {
    this.initialize()
  },
  methods: {
    initialize() {
      // 各種値をAPIで取得する
      const apis = [
        // url : callback
        {url: '/comparison', params: {}, callback: this.getUserBaseComparisons},
      ];
      sendGetParallelApi(apis)
    },
    /**
     * 非同期通信の結果を返す
     * @param response
     * @returns {boolean}
     */
    checkResponse(response) {
      const result = response.data?.result || 0;
      const data = response.data?.data || null;
      return result === true && data !== null;
    },
    getUserBaseComparisons(response) {
      // 比較基準で設定された店舗を取得する
      if(this.checkResponse(response)) {
        let comparisons = response.data.data;
        let param = {
          'store_id' : this.$store.getters["comparison/store_id"] ?? comparisons.store_id
        }
        // 各種値をAPIで取得する
        const apis = [
          // url : callback
          {url: '/store/scale', params: param, callback: this.setScale},
          {url:  '/store/baseInfo', params: param, callback: this.setBaseInfo},
          {url:  '/store/otherService', params: param, callback: this.setOtherService},
        ];
        sendGetParallelApi(apis)
      } else {
        // 比較基準が取得できない場合は、比較基準の設定ページへ
        this.$router.push('/comparison/base')
      }
    },
    setScale(response) {
      if(this.checkResponse(response)) {
        let data = response.data.data;
        this.scale.corporation_estimate_sales = data.corporation_estimate_sales
        this.scale.store_estimate_sales = data.store_estimate_sales
        this.scale.seat_num = data.seat_num
      }
    },
    setBaseInfo(response) {
      if(this.checkResponse(response)) {
        let data = response.data.data;
        this.baseInfo.store_code = data.store_code;
        this.baseInfo.store_name = data.store_name;
        this.baseInfo.corporation_code = data.company_code;
        this.baseInfo.corporation_name = data.company_name;
        this.baseInfo.pref = data.pref;
        this.baseInfo.address = data.address;
        this.baseInfo.open_date = data.open_date;
        this.baseInfo.industry = data.industry_name;
      }
    },
    setOtherService(response) {
      if(this.checkResponse(response)) {
        let data = response.data.data;
        this.otherService.target_date_from = data.first_sales_date
        this.otherService.target_date_to = data.last_sales_date
      }
    }
  }
}
</script>
